import type { HasPassengersOnBoardVehicleFragment } from './hasPassengersOnBoard.hook'
import { getOnBoardTripIds } from './passenger-filters'

/**
 * Whether anyone is on board, by the rule of `getOnBoardTripIds`. Without waypoint data, for example
 * after a failed request, it returns `true`, so flows that hand over to rider support for
 * passengers still do.
 */
export const hasPassengersOnBoard = (
  vehicle: HasPassengersOnBoardVehicleFragment,
): boolean => {
  const waypoints = vehicle.fccUpcomingWaypoints
  return !waypoints || getOnBoardTripIds(waypoints).size > 0
}
